// imports
import { FC } from 'react';
// component
import SidebarMain from 'components/common/SidebarMain';
//constants
import { STAFF_GENERAL_LIST } from 'constants/index';

const GeneralList: FC = () => <SidebarMain list={STAFF_GENERAL_LIST} />;

export default GeneralList;
